<template>
  <form @submit.prevent="submitForm">
    <Card :title="user?.fullname">
      <template #cardToolbar>
        <div class="d-flex align-items-center justify-content-between">
          <span class="mt-5 fw-bold fs-2x flex-grow-1"> {{ formattedLocalAmount(netPaid) }} {{ currency }} </span>
        </div>
      </template>
      <template #cardBody>
        <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x fs-5 fw-bold">
          <li class="nav-item">
            <a class="nav-link text-active-primary ms-0 me-10 py-5 active" data-bs-toggle="tab" href="#revenue-tab">
              {{ $t("payslip.label.income") }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-active-primary ms-0 me-10 py-5" data-bs-toggle="tab" href="#social-contribution-tab">
              {{ $t("payslip.label.socialContribution") }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-active-primary ms-0 me-10 py-5" data-bs-toggle="tab" href="#employee-charge-tab">
              {{ $t("payslip.label.employeeCharge") }} 
            </a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="revenue-tab" role="tabpanel">
            <PayslipRevenuForm :data="formData" :parent-id="parentId" :currency="currency" />
          </div>
          <div class="tab-pane fade" id="social-contribution-tab" role="tabpanel">
            <PayslipSocialContributionForm :data="formData" :base_salary="grossSalary" :parent-id="parentId" :currency="currency" />
          </div>
          <div class="tab-pane fade"  id="employee-charge-tab" role="tabpanel">
            <PayslipEmployerChargeForm :data="formData" :base_salary="grossSalary" :parent-id="parentId" :currency="currency" />
          </div>
        </div>
      </template>
      <template #cardFooter>
        <div class="d-flex justify-content-end align-items-center">
          <Button
              type="cancel"
              btn-class="btn-sm me-3"
              btn-text="button.cancel"
              @click.prevent="cancel"
          />
          <Button
              type="submit"
              btn-class="btn-sm"
              btn-text="button.save"
              :is-loading="isLoading"
          />
        </div>
      </template>
    </Card>
  </form>
</template>

<script setup>

import Card from "@/components/Card.vue";
import Button from "@/components/Button.vue";
import {computed, onMounted, ref} from "vue";
import PayslipRevenuForm from "@/Modules/RH/components/Payslip/PayslipRevenuForm.vue";
import PayslipSocialContributionForm from "@/Modules/RH/components/Payslip/PayslipSocialContributionForm.vue";
import PayslipEmployerChargeForm from "@/Modules/RH/components/Payslip/PayslipEmployerChargeForm.vue";
import {useStore} from "vuex";
import {formattedLocalAmount} from "@/mixins/Helpers";

const store = useStore()
const props = defineProps({
  parentId: { type: String, required: false },
  user: { type: Object, required: true },
  isLoading: { type: Boolean, default: false },
  payslip: {
    type: Object,
    default: () => ({
      payslip_id: "",
      office_id: "",
      user_id: "",
      month: "",
      year: "",
      base_salary: "",
      allowances: [{
        id: "",
        value: 0,
        edited: false
      }],
      others: [{
        id: "",
        value: 0,
        edited: false
      }],
      pensions: [{
        id: "",
        value: 1,
        edited: false
      }],
      taxes: [{
        id: "",
        value: 1,
        edited: false
      }],
      pension_employers: [{
        id: "",
        value: 1,
        edited: false
      }],
      taxe_employers: [{
        id: "",
        value: 1,
        edited: false
      }],
    })
  },
  currency: String,
  cancel: Function,
  submitForm: Function
})

const formData = ref(props.payslip)

const totalAllowances = computed(() =>
    formData.value.allowances.reduce((acc, cur) => acc + (parseFloat(cur.value) || 0), 0)
);
const totalOthers = computed(() => formData.value.others.reduce((acc, cur) => acc + (parseFloat(cur.value) || 0), 0))
const grossSalary = computed(() => totalAllowances.value + totalOthers.value + parseFloat(formData.value.base_salary))
const totalSocialPensions = computed(() => formData.value.pensions.reduce((acc, cur) => acc + (parseFloat(cur.value) || 0), 0))
const totalSocialTaxes = computed(() => formData.value.taxes.reduce((acc, cur) => acc + (parseFloat(cur.value) || 0), 0))
const netPaid = computed(() => grossSalary.value - (totalSocialPensions.value + totalSocialTaxes.value))


onMounted(() => {
  Promise.all([
      store.dispatch('allowances/loadAllowances'),
      store.dispatch('others/loadOthers'),
      store.dispatch('pensions/loadPensions'),
      store.dispatch('pensions/loadPensionTypeEnum'),
      store.dispatch('payrollTaxes/loadPayslipTaxes'),
      store.dispatch('payrollTaxes/loadPayslipTaxeTypeEnum'),
  ])
      .then()
      .finally(() => {})
})


</script>

<style scoped>

</style>